import translate from './i18n';
import TitleComponent from '../TitleComponent/index.vue';

export default {
  props: {
    advertisementsData: {
      type: Object,
      default: () => {},
    },
    price: {
      type: Number,
      default: 0,
    },
  },
  components: {
    TitleComponent,
  },
  data() {
    return ({
      dataChecks: [
        {
          name: 'Вид звіту',
          link: {
            href: '/vue/technicalcheck/248622/?hash=MTcxNTk5NzYzODgzMA==',
            text: 'Приклад звіту',
            icon: 'i16_link',
          },
        },
        {
          name: 'Компютерна діагностика',
        },
        {
          name: 'Поверхневий огляд двигуна',
        },
        {
          name: 'Перевірка кузова',
        },
        {
          name: 'Огляд салону',
        },
        {
          name: 'Перевірка світлових приладів',
        },
        {
          name: 'Огляд шин та дисків',
        },
        {
          name: 'Фото та відеозвіт',
        },
      ],
    });
  },
  methods: {
    orderInspection() {
      this.$emit('handleClick', { name: 'OrderInspection' });
    },
  },
  i18n: {
    ...translate,
  },
};
